import throttle from 'lodash/throttle';

const stateAttr = 'data-component-topbar-state';

const states = {
  VISIBLE: 'visible',
  HIDDEN: 'hidden',
};

const scrollDelta = 8;

const getHeader = () => document.querySelector('[data-component="header"]');

let initialized = false;
let lastScroll = 0;

function setState(state) {
  const header = getHeader();
  if (!header) return;
  header.setAttribute(stateAttr, state);
}

function applyStickyNav() {
  const header = getHeader();
  if (!header) return;

  if (header.classList.contains('is-menu-open')) {
    lastScroll = window.scrollY;
    return;
  }

  const currentScroll = window.scrollY;

  if (currentScroll <= 0) {
    setState(states.VISIBLE);
    lastScroll = currentScroll;
    return;
  }
  if (Math.abs(currentScroll - lastScroll) < scrollDelta) return;
  if (currentScroll > lastScroll && currentScroll > header.offsetHeight) {
    setState(states.HIDDEN);
  } else if (currentScroll < lastScroll) {
    setState(states.VISIBLE);
  }
  lastScroll = currentScroll;
}

export default (function () {
  return {
    init() {
      const header = getHeader();

      if (!header || initialized) return;

      initialized = true;
      lastScroll = window.scrollY;

      setState(states.VISIBLE);

      window.addEventListener('scroll', throttle(applyStickyNav, 50));
    },
  };
})();
